export default __webpack_public_path__ + "static/media/cloud.7ac50f09.png";